import { useParams, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

import { isValidUUID } from 'app/utils';

export default function MasterServiceGuard({ children }) {
  const { masterServiceId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isValidUUID(masterServiceId)) {
      const redirectUrl = `/master-services`;
      navigate(redirectUrl);
    }
  }, [masterServiceId, navigate]);

  if (!isValidUUID(masterServiceId)) {
    return null;
  }

  return children;
}
